module.exports = __webpack_public_path__ + "static/media/max.0bbb0e91.png";